module.exports = __webpack_public_path__ + "img/funpinpin.7082053e.png";